(() => {
  const html = document.documentElement;

  const closeDrawer = (drawer) => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    html.classList.remove('massa-drawer-open');
    const burger = document.querySelector('[data-massa-drawer-open]');
    if (burger) burger.setAttribute('aria-expanded', 'false');
  };

  const openDrawer = (drawer) => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    html.classList.add('massa-drawer-open');
    const burger = document.querySelector('[data-massa-drawer-open]');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    const closeBtn = drawer.querySelector('[data-massa-drawer-close]');
    if (closeBtn) closeBtn.focus();
  };

  const syncFooterAccordions = () => {
    const desktop = window.matchMedia('(min-width: 750px)').matches;
    document.querySelectorAll('.massa-footer__acc').forEach((item) => {
      if (desktop) item.setAttribute('open', '');
      else item.removeAttribute('open');
    });
  };

  const setupReveals = () => {
    const nodes = document.querySelectorAll(
      '.massa-section-head, .massa-collections__card, .massa-card, .massa-story, .massa-promo, .massa-symbol, .massa-news'
    );
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach((node) => node.classList.add('is-in'));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    nodes.forEach((node) => {
      if (node.classList.contains('massa-reveal-onscroll')) return;
      const rect = node.getBoundingClientRect();
      const alreadyVisible = rect.top < window.innerHeight * 0.92 && rect.bottom > 0;
      node.classList.add('massa-reveal-onscroll');
      if (alreadyVisible) {
        node.classList.add('is-in');
      } else {
        observer.observe(node);
      }
    });
  };

  const setupCarousels = () => {
    document.querySelectorAll('[data-massa-carousel]').forEach((track) => {
      if (track.dataset.massaBound === 'true') return;
      track.dataset.massaBound = 'true';
      const dotsWrap = track.parentElement.querySelector('[data-massa-carousel-dots]');
      const cards = Array.from(track.children);
      if (!cards.length) return;

      const update = () => {
        const overflowing = track.scrollWidth > track.clientWidth + 8;
        if (dotsWrap) dotsWrap.hidden = !overflowing;
        if (!overflowing || !dotsWrap) return;
        const cardWidth = cards[0].getBoundingClientRect().width || 1;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        const index = Math.round(track.scrollLeft / (cardWidth + gap));
        dotsWrap.querySelectorAll('button').forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
        });
      };

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });

      if (dotsWrap) {
        dotsWrap.querySelectorAll('button').forEach((dot, i) => {
          dot.addEventListener('click', () => {
            cards[i]?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          });
        });
      }

      update();
    });
  };

  const setupCampaignVideos = () => {
    document.querySelectorAll('.massa-promo__video').forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      const tryPlay = () => {
        const play = video.play();
        if (play && typeof play.catch === 'function') play.catch(() => {});
      };
      if (video.readyState >= 2) tryPlay();
      else video.addEventListener('canplay', tryPlay, { once: true });
    });
  };

  const wrapArabic = () => {
    const arabic = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
    document.querySelectorAll('.massa-accordions__body--bidi').forEach((root) => {
      if (root.dataset.massaRtl === 'true') return;
      root.dataset.massaRtl = 'true';
      root.querySelectorAll('p, li, div, h1, h2, h3, h4, h5, h6').forEach((el) => {
        const text = (el.textContent || '').trim();
        if (!text || !arabic.test(text)) return;
        const letters = text.replace(/[^A-Za-z\u0600-\u06FF]/g, '');
        const arabicLetters = (letters.match(/[\u0600-\u06FF]/g) || []).length;
        if (arabicLetters > letters.length * 0.4) {
          el.setAttribute('dir', 'rtl');
          el.setAttribute('lang', 'ar');
        }
      });
    });
  };

  const measureHeader = () => {
    const group = document.querySelector('#header-group');
    const headerEl = document.querySelector('.massa-header') || document.querySelector('#header-component');
    if (!headerEl) return;
    document.body.style.setProperty('--header-height', `${headerEl.offsetHeight}px`);
    if (group) {
      document.body.style.setProperty('--header-group-height', `${group.offsetHeight}px`);
    }
  };

  const onScroll = () => {
    const header = document.querySelector('.massa-header');
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 8);
  };

  const init = () => {
    measureHeader();
    onScroll();
    syncFooterAccordions();
    setupReveals();
    setupCarousels();
    setupCampaignVideos();
    wrapArabic();
  };

  if (!window.__massaPolishBound) {
    window.__massaPolishBound = true;

    document.addEventListener('click', (event) => {
      const drawer = document.querySelector('[data-massa-drawer]');
      if (event.target.closest('[data-massa-drawer-open]')) {
        openDrawer(drawer);
      }
      if (event.target.closest('[data-massa-drawer-close]')) {
        closeDrawer(drawer);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawer(document.querySelector('[data-massa-drawer]'));
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      measureHeader();
      syncFooterAccordions();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
